(function () {
  var box = document.querySelector('[data-buy-box]');
  if (!box) return;

  var variantIn  = box.querySelector('[data-variant-input]');
  var planIn     = box.querySelector('[data-plan-input]');
  var qtyIn      = box.querySelector('[data-qty]');
  var totalEl    = box.querySelector('[data-total]');
  var totalWasEl = box.querySelector('[data-total-was]');
  var renewEl    = box.querySelector('[data-renew]');
  var atc        = box.querySelector('[data-atc]');
  var atcLabel   = box.querySelector('[data-atc-label]');
  var toggle     = box.querySelector('[data-mode-toggle]');
  var banner     = box.querySelector('[data-sub-banner]');
  var tiers      = [].slice.call(box.querySelectorAll('[data-tier]'));
  var mainImage  = document.getElementById('buyMainImage');
  var thumbs     = [].slice.call(box.querySelectorAll('.bm-thumbs img'));
  var mobileBar  = document.querySelector('[data-mobile-bar]');
  var mbTotal    = mobileBar && mobileBar.querySelector('[data-mb-total]');
  var mbCta      = mobileBar && mobileBar.querySelector('[data-mb-cta]');
  var format     = box.getAttribute('data-money-format') || '${{amount}}';
  var hasPlans   = box.getAttribute('data-has-plans') === 'true';
  var bumpEl     = document.querySelector('[data-bump]');
  function bumpOn() { return !!(bumpEl && bumpEl.checked); }
  function bumpPrice() { return bumpOn() ? parseInt(bumpEl.getAttribute('data-bump-price'), 10) : 0; }

  // Subscription is the default. One-time is opt-in via the text link.
  var subscribing = hasPlans;

  var LINK_ONETIME   = toggle ? toggle.textContent : '';
  var LINK_SUBSCRIBE = box.getAttribute('data-subscribe-link') || 'Subscribe & save instead';

  /* ---------- money ---------- */
  function group(n, sep) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep); }
  function money(cents) {
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var amount = cents / 100.0, value;
    switch (key) {
      case 'amount_no_decimals':
        value = group(Math.round(amount).toString(), ','); break;
      case 'amount_with_comma_separator':
        value = group(amount.toFixed(2), '.').replace(/\.(\d\d)$/, ',$1'); break;
      case 'amount_no_decimals_with_comma_separator':
        value = group(Math.round(amount).toString(), '.'); break;
      case 'amount_with_apostrophe_separator':
        value = group(amount.toFixed(2), "'"); break;
      default:
        value = group(amount.toFixed(2), ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function currentTier() {
    return tiers.filter(function (t) { return t.classList.contains('on'); })[0] || tiers[0] || null;
  }
  function qty() {
    var n = parseInt(qtyIn && qtyIn.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 10) n = 10;
    return n;
  }
  function unitPrice(tier) {
    var p = parseInt(tier.getAttribute(subscribing ? 'data-sub-price' : 'data-price'), 10);
    return isNaN(p) ? 0 : p;
  }

  /* ---------- render every tier row ---------- */
  function renderTiers() {
    tiers.forEach(function (tier) {
      var priceEl = tier.querySelector('[data-tier-price]');
      var wasEl   = tier.querySelector('[data-tier-was]');
      var subEl   = tier.querySelector('[data-tier-sub]');
      var oneTime = parseInt(tier.getAttribute('data-price'), 10);
      var subP    = parseInt(tier.getAttribute('data-sub-price'), 10);
      var compare = parseInt(tier.getAttribute('data-compare'), 10);
      var units   = parseInt(tier.getAttribute('data-units'), 10);
      var shown   = subscribing ? subP : oneTime;

      if (priceEl) priceEl.textContent = money(shown);

      if (wasEl) {
        if (compare && compare > shown) wasEl.textContent = money(compare);
        else if (subscribing && subP < oneTime) wasEl.textContent = money(oneTime);
        else wasEl.textContent = '';
      }

      if (subEl) {
        var bits = [];
        if (units && units > 0) bits.push(money(Math.round(shown / units)) + ' per bar');
        if (compare && compare > shown) {
          bits.push('save ' + money(compare - shown));
        } else if (subscribing && subP < oneTime) {
          bits.push('save ' + money(oneTime - subP));
        }
        if (!tier.getAttribute('data-available') || tier.getAttribute('data-available') !== 'true') {
          subEl.textContent = 'Sold out';
        } else {
          subEl.textContent = bits.join(' · ');
        }
      }
    });
  }

  function render() {
    var tier = currentTier();
    if (!tier) return;
    var available = tier.getAttribute('data-available') === 'true';

    if (variantIn) variantIn.value = tier.getAttribute('data-variant-id');
    if (planIn) planIn.value = subscribing ? (tier.getAttribute('data-plan') || '') : '';

    renderTiers();

    var net = unitPrice(tier) * qty() + bumpPrice();
    var listed = parseInt(tier.getAttribute('data-price'), 10) * qty() + bumpPrice();
    if (totalEl) totalEl.textContent = money(net);
    if (mbTotal) mbTotal.textContent = money(net);
    if (totalWasEl) totalWasEl.innerHTML = (net < listed) ? '<s>' + money(listed) + '</s>' : '';

    if (renewEl) {
      var planName = (tier.getAttribute('data-plan-name') || '').toLowerCase();
      var cadence = planName ? planName.replace(/^\s*every\s+/, '').replace(/\s*subscription.*$/, '').trim() : '';
      if (!cadence) cadence = 'month';
      cadence = cadence.replace(/^1\s+/, '');
      renewEl.textContent = subscribing
        ? 'Renews at ' + money(unitPrice(tier)) + ' every ' + cadence + '. Skip, pause or cancel anytime.'
        : 'One-time purchase. No subscription, no renewal.';
    }

    if (banner) banner.classList.toggle('off', !subscribing);
    if (toggle) toggle.textContent = subscribing ? LINK_ONETIME : LINK_SUBSCRIBE;

    if (atc) {
      atc.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? (atc.getAttribute('data-label') || 'Checkout Now') : 'Sold out';
    }
  }

  tiers.forEach(function (tier) {
    tier.addEventListener('click', function (e) {
      if (tier.classList.contains('sold-out')) { e.preventDefault(); return; }
      tiers.forEach(function (t) { t.classList.remove('on'); });
      tier.classList.add('on');
      var radio = tier.querySelector('input[type=radio]');
      if (radio) radio.checked = true;
      render();
    });
  });

  if (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      subscribing = !subscribing;
      render();
    });
  }

  var down = box.querySelector('[data-qty-down]');
  var up   = box.querySelector('[data-qty-up]');
  function setQty(n) {
    if (n < 1) n = 1;
    if (n > 10) n = 10;
    qtyIn.value = n;
    if (down) down.disabled = n <= 1;
    if (up) up.disabled = n >= 10;
    render();
  }
  if (down) down.addEventListener('click', function () { setQty(qty() - 1); });
  if (up)   up.addEventListener('click', function () { setQty(qty() + 1); });
  if (qtyIn) {
    qtyIn.addEventListener('change', function () { setQty(qty()); });
    qtyIn.addEventListener('input', render);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      if (mainImage) mainImage.src = t.getAttribute('data-full');
    });
  });

  /* ---------- scrolling to the offer ---------- */
  // Nothing above the offer may add to cart. A visitor who has not reached the
  // bundle selector has not chosen a bundle, so every CTA before it scrolls.
  function scrollToOffer() {
    var target = document.getElementById('buy') || box;
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (target.scrollIntoView) {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } else {
      window.location.hash = 'buy';
    }
  }

  // Smooth-scroll every in-page anchor, honouring reduced-motion. CSS already sets
  // scroll-behavior; this is the fallback for browsers that ignore it, and it keeps
  // the URL clean rather than stamping #buy into history on every CTA click.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a || e.defaultPrevented) return;
    if (a.hasAttribute('data-mb-cta') || a.hasAttribute('data-mode-toggle')) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  if (mobileBar && atc) {
    // The sticky bar used to appear whenever the buy card was off screen — which
    // includes being ABOVE it, in the hero. Its CTA fired add-to-cart, so a visitor
    // who had never seen the bundle selector went straight to checkout on the
    // default 1-bar tier. It may now only appear once the offer has been reached
    // and scrolled past, and it still scrolls rather than buys if the offer is
    // below the fold for any reason.
    var seenOffer = false;

    if (mbCta) {
      mbCta.addEventListener('click', function (e) {
        e.preventDefault();
        var r = box.getBoundingClientRect();
        var offerBelowFold = r.top > (window.innerHeight * 0.5);
        if (!seenOffer || offerBelowFold) { scrollToOffer(); return; }
        atc.click();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) seenOffer = true;
          mobileBar.classList.toggle('on', seenOffer && !entry.isIntersecting);
        });
      }, { rootMargin: '-120px 0px -120px 0px' }).observe(box);
    }
  }

  if (bumpEl) bumpEl.addEventListener('change', render);

  /* ---------- checkout: replace the cart, never stack lines ---------- */
  var form = document.getElementById('buyForm');
  if (form && window.fetch) {
    form.addEventListener('submit', function (e) {
      var tier = currentTier();
      if (!tier || tier.getAttribute('data-available') !== 'true') return;
      e.preventDefault();
      if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Just a moment…'; }
      var main = { id: Number(tier.getAttribute('data-variant-id')), quantity: qty() };
      var plan = subscribing ? tier.getAttribute('data-plan') : '';
      if (plan) main.selling_plan = Number(plan);

      // The bump rides along as a separate ONE-TIME line. It never inherits the
      // selling plan - nobody signed up for a recurring tea tree bar.
      var items = [main];
      if (bumpOn()) {
        items.push({ id: Number(bumpEl.getAttribute('data-bump-variant')), quantity: 1 });
      }
      var body = { items: items };
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          // fall back to the plain form post, which also lands on /checkout
          form.submit();
        });
    });
  }

  if (atcLabel) atc.setAttribute('data-label', atcLabel.textContent.trim());
  setQty(qty());
  render();
})();
